<template>
  <van-popup
    :lazy-render="true"
    :overlay="true"
    :position="'right'"
    @click-overlay="overlay"
    class="reg_care_pop"
    v-model="show"
  >
    <div class="reg_care">
      <van-checkbox-group
        :max="5"
        class="care_checkbox"
        v-model="typeValse"
      >
        <van-collapse
          :key="index"
          v-for="(item,index) in typeOption"
          v-model="activeNames"
        >
          <van-collapse-item
            :name="item.id"
            :title="item.nameEn"
            class="care_item"
          >
            <div class="checkbox_wrap">
              <van-checkbox
                :class="{is_active:typeValse.length && mode.isCheck}"
                :key="ind"
                :name="mode.id"
                @click="checkChange(item.childrens,mode)"
                v-for="(mode,ind) in item.childrens"
              >{{mode.showName}}</van-checkbox>
            </div>
          </van-collapse-item>
        </van-collapse>
      </van-checkbox-group>
    </div>
    <div class="cate_btn">
      <div
        @click="reSet"
        class="btn re_set"
      >Clear</div>
      <div
        @click="submit"
        class="btn save"
      >Save</div>
    </div>
  </van-popup>
</template>
<script>
export default {
  name: "reg-care",
  props: ['cateList', 'showCategory', 'selectList'],
  data () {
    return {
      show: false,
      activeNames: [],
      typeOption: [],
      typeValse: [],
      data1: '',
      data2: '',
      newlist: [],
      valseLen: 0,
      checkList: '', // 选中的类别字符串型
    };
  },
  watch: {
    showCategory () {
      this.show = this.showCategory;
    }
  },
  created () {
    // this.typeOption=this.getList(this.list);
    // this.activeName.push(categoryData[0].id);
  },
  methods: {
    overlay () {
      this.show = false;
    },
    open () {
      this.category = this.cateList || []; // 获取小秘书的服务类别;
      this.show = true;
      this.category.forEach(v => {
        this.activeNames.push(v.id)
      })
      this.typeOption = JSON.parse(JSON.stringify(this.category));
      let arr = this.selectList;
      let typeList = [];
      arr.forEach(c => {
        let arr1 = [];
        arr1 = c.split('>');
        typeList.push(arr1);
      })
      let typeListId = [];
      this.typeOption.forEach(ele => {
        if (!ele.childrens) {
          ele.childrens = [];
          ele.childrens.unshift({ id: ele.id, nameEn: ele.nameEn, showName: 'All' })
        } else {
          ele.childrens.unshift({ id: ele.id, name: ele.name, showName: "All" });
        }
        typeList.forEach(c => {
          if (c[0] == ele.nameEn) {  // 父级
            if (ele.childrens) {
              ele.childrens.forEach(mode => {
                if (c.includes(mode.nameEn)) {
                  if (mode.showName != 'All' || c.length == 1) {
                    typeListId.push(mode.id)
                  }
                }
              })
            }
          }
        })
      })
      this.checkList = '';
      this.typeValse = typeListId;
      this.typeValse = Array.from(new Set(this.typeValse)) //去除重复的数据
      console.log(this.typeOption, this.typeValse, '新的选中的感兴趣数组')
      this.typeOption.forEach(ele => {
        if (ele.childrens) {
          ele.childrens.forEach(mode => {
            if (!mode.showName) {
              mode.showName = mode.nameEn
            }
            if (this.typeValse.includes(mode.id)) {
              mode.isCheck = true;
            } else {
              mode.isCheck = false;
            }
          })
        }
      })
      this.valseLen = this.typeValse.length;
      console.log(this.typeOption, this.valseLen, 'this.typeOption')
    },
    //获取数组  传一个数组json 遍历其下 id 于 name isLists 是否获取其list
    getList (arrJson, isLists = true) {
      let classArr = [];
      if (isLists) {
        if (arrJson) {
          arrJson.forEach(el => {
            classArr.push({
              id: el.id,
              nameEn: el.nameEn,
              Lists: this.getList(el.childrens, false)
            })
          });
        }
      }
      else {
        if (arrJson) {
          arrJson.forEach(el => {
            classArr.push({
              id: el.id,
              nameEn: el.nameEn,
            })
          });
        }
      }
      return classArr
    },
    reSet () {
      this.typeValse = [];
      this.valseLen = 0;
    },
    //保存
    submit () {
      this.show = false;
      this.typeOption.forEach(ele => {
        if (ele.childrens) {
          ele.childrens.forEach(mode => {
            if (this.typeValse.includes(mode.id)) {
              // mode.isCheck=true;
              let check = '';
              if (ele.nameEn == mode.nameEn) {
                check = ele.nameEn
              } else {
                check = ele.nameEn + '>' + mode.nameEn;
              }
              this.checkList = this.checkList + check + ';';
            }
          })
        }
      })
      // this.edTypevalues();
      this.$emit('closePop', this.checkList.slice(0, this.checkList.length - 1), this.typeValse);
    },

    checkChange (arr, e) {
      // console.log(this.valseLen,'lenene')
      let bool = this.typeValse.includes(e.id);
      let isOk = false;
      if (this.typeValse.length == this.valseLen && this.valseLen == 5 && !bool) {
        if (e.showName == 'All') {
          for (let i = 0; i < arr.length; i++) {
            let c = arr[i];
            if (c.showName != 'All') {
              if (this.typeValse.includes(c.id)) {
                // console.log('push')
                this.typeValse.push(e.id);
                // console.log(this.typeValse,'sssss')
                this.isOk = true;
                break
              }
            }
          }
        } else {
          for (let i = 0; i < arr.length; i++) {
            let c = arr[i];
            if (c.showName == 'All') {
              if (this.typeValse.includes(c.id)) {
                // console.log('push')
                this.typeValse.push(e.id);
                // console.log(this.typeValse,'sssss')
                this.isOk = true;
                break
              }
            }
          }
        }
      }
      bool = this.typeValse.includes(e.id);
      // console.log(this.typeValse,'hah ')
      if (this.typeValse.length == this.valseLen && this.valseLen == 5 && !isOk) {
        this.$toast.fail('5 choosen at most');
        return
      }
      if (e.showName == 'All' && bool) {
        arr.forEach(e => {
          if (e.showName != 'All') {
            let i = this.typeValse.findIndex(item => item === e.id);
            if (i != -1) {
              this.typeValse.splice(i, 1);
            }
          }
        })
      } else if (e.showName != 'All' && bool) {
        arr.forEach(e => {
          if (e.showName == 'All') {
            let i = this.typeValse.findIndex(item => item === e.id);
            if (i != -1) {
              this.typeValse.splice(i, 1);
            }
          }
        })
      }
      // console.log(arr,e,'改变');
      // console.log(this.typeValse,'已选数组')
      this.valseLen = this.typeValse.length
    }
  },
};
</script>

<style lang="scss" scoped>
.reg_care_pop {
  width: 80%;
  height: 100vh;
  background: ffffff;
  color: #333;
  .reg_care {
    padding: 0.24rem 0.24rem 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    height: calc(100% - 1.18rem);
    width: 100%;
    overflow-y: auto;
    &::v-deep .care_checkbox {
      display: block;
      .van-checkbox {
        margin: 0 0.16rem 0.16rem 0;
        padding: 0 0.18rem;
        // height: 0.54rem;
        line-height: 0.54rem;
        // border: 1px solid #bfbfbf;
        background: #f4f4f4;
        border-radius: 3px;

        &[aria-checked="true"] {
          background: #f85a10;
          .van-checkbox__label {
            color: #fff;
          }
        }
        .van-checkbox__icon {
          display: none;
        }
        .van-checkbox__label {
          color: #333;
          margin-left: 0;
          line-height: 0.54rem;
        }
      }
      .van-collapse {
        &::after {
          display: none;
        }
        .care_item {
          .van-collapse-item__title {
            padding: 0;
            height: 0.65rem;
            background: transparent;
            &[aria-expanded="true"] {
              .van-cell__title::after {
                content: "collapse";
              }
            }
            &::after {
              display: none;
            }
            .van-cell__title {
              line-height: 0.65rem;
              color: #666;
              display: flex;
              justify-content: space-between;
              &::after {
                content: "expand";
                line-height: 0.65rem;
                color: #333;
                font-size: 0.26rem !important;
              }
              span {
                font-size: 0.26rem !important;
              }
            }
            .van-icon {
              line-height: 0.65rem;
              height: auto;
              font-size: 0.24rem;
              color: #666;
              margin-left: 0.1rem;
            }
          }
          .van-collapse-item__content {
            background: transparent;
            padding: 0;
            line-height: 1;
            .checkbox_wrap {
              display: flex;
              flex-wrap: wrap;
            }
          }
        }
      }
    }
  }
  .sumbit_btn {
    font-size: 0.36rem;
    height: 0.98rem;
    line-height: 0.98rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 0;
    span {
      font-size: 0.36rem;
    }
  }
  .cate_btn {
    width: 100%;
    height: 1.18rem;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    padding: 0.25rem 0.24rem 0.25rem 0;
    z-index: 9;
    .btn {
      height: 100%;
      width: 1.88rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 99px;
      &.re_set {
        border: solid 1px #999;
        color: #333;
        font-size: 0.26rem;
        margin-left: auto;
      }
      &.save {
        margin-left: 0.2rem;
        font-size: 0.26rem;
        color: #fff;
        background-image: linear-gradient(
            90deg,
            #ffa600 0%,
            #ffba00 100%,
            #ffb000 100%,
            #ffa600 100%,
            #ffb100 100%,
            #ffbc00 100%
          ),
          linear-gradient(#1890ff, #1890ff);
      }
    }
  }
}
</style>
